
import {
    Dashboard as DashboardIcon,
    Event as EventIcon,
    Business as BusinessIcon,
    Inventory as InventoryIcon,
    Build as BuildIcon,
    People as PeopleIcon,
    GavelRounded as GavelIcon,
    LocalShipping as LocalShippingIcon,
    Label as LabelIcon,
    Email as EmailIcon,
    ShoppingCart as ShoppingCartIcon,
    Description as DescriptionIcon,
    Person as PersonIcon,
    Backup as BackupIcon,
    BeachAccess as VacationIcon,
    Assignment as AssignmentIcon,
    SettingsBackupRestore as SettingsBackupRestoreIcon,
    School as SchoolIcon,
} from '@mui/icons-material';
import ConnectedTvIcon from '@mui/icons-material/ConnectedTv';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Router as RouterIcon } from '@mui/icons-material';
import OdooIcon from '../assets/icons/OdooIcon';

/**
 * Ritorna la lista statica di tutte le possibili applicazioni del sistema.
 * @param {object} theme - L'oggetto tema di MUI per accedere ai colori.
 * @returns {Array<object>} - Un array di oggetti applicazione.
 */
export const getAppList = (theme) => [
    {
        title: 'Dashboard Dati',
        description: 'Visualizza statistiche e metriche chiave',
        icon: DashboardIcon,
        path: '/dashboard',
        color: theme.palette.primary.main,
        resource: 'dashboard',
    },
    {
        title: 'Calendario',
        description: 'Gestisci eventi e appuntamenti',
        icon: EventIcon,
        path: '/calendar',
        color: theme.palette.success.main,
        resource: 'calendars'
    },
    {
        title: 'Visitatori',
        description: 'Registra e gestisci gli accessi dei visitatori',
        icon: PersonIcon,
        path: '/visitors',
        color: '#C98BB9',
        resource: 'visitors'
    },
    {
        title: 'Antincendio',
        description: 'Registro e manutenzione dei dispositivi antincendio',
        icon: LocalFireDepartmentIcon,
        path: '/fire',
        color: '#34113F',
        resource: 'fire'
    },
    {
        title: 'Contatti',
        description: 'Anagrafica e gestione contatti',
        icon: BusinessIcon,
        path: '/contacts',
        color: theme.palette.info.main,
        resource: 'suppliers'
    },
    {
        title: 'Certificati Fornitori',
        description: 'Gestisci i certificati ISO dei fornitori',
        icon: DescriptionIcon,
        path: '/supplier-certificates',
        color: '#8e44ad',
        resource: 'supplierCertificates'
    },
    {
        title: 'Prodotti',
        description: 'Gestione catalogo e inventario prodotti',
        icon: InventoryIcon,
        path: '/products',
        color: theme.palette.warning.main,
        resource: 'products'
    },

    {
        title: 'Gestione Indirizzi IP',
        description: 'Traccia e gestisci i dispositivi della tua rete',
        icon: RouterIcon,
        path: '/network-devices',
        color: '#00bfa5',
        resource: 'networkDevices'
    },

    {
        title: 'Manutenzioni',
        description: 'Pianifica e traccia interventi di manutenzione',
        icon: BuildIcon,
        path: '/maintenances',
        color: theme.palette.error.main,
        resource: 'maintenances'
    },
    {
        title: 'Tracciamento GLS',
        description: 'Traccia le spedizioni GLS',
        icon: LocalShippingIcon,
        path: '/gls-tracking',
        color: theme.palette.secondary.main,
        resource: 'gls-tracking'
    },
    {
        title: 'Esenzioni',
        description: 'Gestione delle esenzioni per i clienti',
        icon: GavelIcon,
        path: '/exemptions',
        color: '#9c27b0',
        resource: 'exemptions'
    },
    {
        title: 'Timbrature',
        description: 'Visualizza le tue timbrature',
        icon: AccessTimeIcon,
        path: '/timestamps',
        color: '#00e5ffff',
        resource: 'timestamps'
    },
    {
        title: 'Odoo',
        description: 'Traccia ordini e visioni',
        icon: OdooIcon,
        path: '/po-tracking',
        color: '#714B67',
    },
    {
        title: 'Ritiri/triangolazioni',
        description: 'Richiesta triangolazioni o ritiri di prodotti',
        icon: LocalShippingIcon,
        path: '/shipments',
        color: '#5259489',
        resource: 'shipments'
    },
    {
        title: 'Grafiche',
        description: 'Genera e stampa etichette',
        icon: LabelIcon,
        path: '/batch-label',
        color: '#607d8b',
        resource: 'labels'
    },
    {
        title: 'Dipendenti',
        description: 'Configura dipendenti',
        icon: EmailIcon,
        path: '/recipients',
        color: '#ff9800',
        resource: 'recipients'
    },
    {
        title: 'Acquisti',
        description: 'Gestione ordini di acquisto',
        icon: ShoppingCartIcon,
        path: '/purchases',
        color: '#009688',
        resource: 'purchases'
    },
    {
        title: 'Corsi',
        description: 'Gestione corsi di formazione',
        icon: SchoolIcon,
        path: '/courses',
        color: '#1976d2',
        resource: 'courses'
    },
    {
        title: 'Vendite',
        description: 'Gestione ordini di vendita',
        icon: ShoppingCartIcon,
        path: '/admin/orders',
        color: '#eef200ff',
        resource: 'sales'
    },
    {
        title: 'Dichiarazioni',
        description: 'Gestisci dichiarazioni di libera esportazione',
        icon: DescriptionIcon,
        path: '/declarations',
        color: '#673ab7',
        resource: 'declarations'
    },
    {
        title: 'Gestione Dotazioni',
        description: 'Assegna e monitora i dispositivi aziendali',
        icon: AssignmentIcon,
        path: '/assignments',
        color: '#26a69a',
        resource: 'assignments'
    },
    {
        title: 'Gestione Utenti',
        description: 'Amministra utenti e permessi del sistema',
        icon: PeopleIcon,
        path: '/users',
        color: '#3f51b5',
        resource: 'users'
    },
    {
        title: 'Digital Signage',
        description: 'Imposta lo schermo di presentazione (link esterno)',
        icon: ConnectedTvIcon,
        path: 'http://192.168.10.16:5005',
        color: '#00D9C0',
        // Nessuna risorsa, accessibile a tutti gli utenti loggati
    },
    {
        title: 'Backup & Restore',
        description: 'Esegui e gestisci i backup dei dati',
        icon: BackupIcon,
        path: '/admin/backup',
        color: '#00bcd4',
        resource: 'backups'
    },
    {
        title: 'Disaster Recovery',
        description: 'Gestisci test e configurazioni di disaster recovery',
        icon: SettingsBackupRestoreIcon,
        path: '/disaster-recovery',
        color: '#d32f2f',
        resource: 'disasterRecovery'
    },
    {
        title: 'Statistiche Ferie',
        description: 'Visualizza e analizza le statistiche sulle ferie',
        icon: VacationIcon,
        path: '/admin/vacations',
        color: '#4caf50',
        resource: 'vacations'
    }
];
